export default {
  SHARED_FOOTER_SIMPLE: {
    COPYRIGHT: '© {{year}}, Legal Labs Kft.',
    TERMS_AND_CONDITIONS: 'Általános Szerződési Feltételek',
    PRIVACY_POLICY: 'Adatvédelmi Irányelvek',
    HELP: 'Segítség',
  },
};
